import { Box, Slide, Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { FontStyle, QuestionData, defaultBottomPadding, defaultInnerStyle, defaultContainerStyle } from '../../constants';
import CheckButton from '../CheckButton';
import HeartButton from '../HeartButton'
import SlideTransition from '../SlideTransition';

const styles = {
  container: {
    ...defaultContainerStyle
  },
  inner: {
    ...defaultInnerStyle,
  },
  viewMore: {
    ...FontStyle.headingBody,
    fontSize: '1rem',
    textAlign: 'inherit',
    color: 'inherit',
    lineHeight: '1.3',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  moreLocations: {
    ...FontStyle.body,
    fontSize: '0.83rem',
    lineHeight: '1.3',
    textAlign: 'inherit',
    color: 'rgb(79, 79, 66)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  }
}
const numNeeded = 1;
const initialLength = 10;

const Q1_Location = ({ selected, setSelected, setQuestionsDone, questionNum, options, setRefreshCount }) => {
  const [viewMore, setViewMore] = React.useState(false);
  useEffect(() => {
    if (selected[questionNum].length >= numNeeded) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }))
    }
  }, [selected])
  return (
    <Stack direction='column' sx={styles.container} alignItems='center' spacing={4}>
      <Stack direction='column' sx={styles.inner} alignItems='center' justifyContent='center' spacing={1}>
        {options.slice(0, initialLength).map((option, i) => {
          return (
            <CheckButton key={i} text={option} selected={selected[questionNum].includes(i)} setSelected={() => {
              if (selected[questionNum].includes(i)) {
                setSelected(s => { return { ...s, [questionNum]: s[questionNum].filter((item) => item !== i) } })
              } else {
                setSelected(s => { return { ...s, [questionNum]: [...s[questionNum], i] } })
              }
            }}
            />
          )
        })}
      </Stack>
      {viewMore ? (<Stack direction='column' sx={styles.inner} alignItems='center' justifyContent='center' spacing={1}>
        <Box sx={styles.moreLocations}>More locations</Box>
        {options.slice(initialLength, options.length).map((option, idx) => {
          const i = initialLength + idx;
          return (
            <CheckButton key={i} text={option} selected={selected[questionNum].includes(i)} setSelected={() => {
              if (selected[questionNum].includes(i)) {
                setSelected(s => { return { ...s, [questionNum]: s[questionNum].filter((item) => item !== i) } })
              } else {
                setSelected(s => { return { ...s, [questionNum]: [...s[questionNum], i] } })
              }
            }}
            />
          )
        })}
      </Stack>

      ) : <Box sx={styles.viewMore}
        onClick={() => { setViewMore(true); setRefreshCount((prev) => prev + 1); }}
      >See more locations</Box>}
    </Stack>
  )
}

export default Q1_Location